// SAD-506: TanStack Query bindings for versioned Win Themes over zou's
// ProjectDataService. A save appends a version, so it also refreshes Outputs
// readiness (the win_themes section reads the latest versions).
import { Code, ConnectError } from '@connectrpc/connect';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { projectDataClient } from '../../../lib/connect/clients';
import { outputsKey } from './hooks';
export const winThemesKey = (pursuitId)=>[
        'win-themes',
        pursuitId
    ];
const historyKey = (pursuitId, id)=>[
        'win-theme-history',
        pursuitId,
        id
    ];
export function useWinThemes(pursuitId) {
    return useQuery({
        queryKey: winThemesKey(pursuitId),
        enabled: !!pursuitId,
        queryFn: async ()=>(await projectDataClient.listWinThemes({
                pursuitId
            })).winThemes
    });
}
export function useWinThemeHistory(pursuitId, winThemeId) {
    return useQuery({
        queryKey: historyKey(pursuitId, winThemeId),
        enabled: !!pursuitId && !!winThemeId,
        queryFn: async ()=>(await projectDataClient.getWinThemeHistory({
                pursuitId,
                winThemeId
            })).winTheme
    });
}
export function useSaveWinTheme() {
    const cache = useQueryClient();
    return useMutation({
        mutationFn: (draft)=>projectDataClient.saveWinThemeVersion({
                pursuitId: draft.pursuitId,
                winThemeId: draft.winThemeId,
                customerThemeId: draft.customerThemeId,
                needSummary: draft.needSummary,
                differentiator: draft.differentiator,
                narrative: draft.narrative,
                claims: draft.claims
            }),
        onSuccess: async (_resp, draft)=>{
            await Promise.all([
                cache.invalidateQueries({
                    queryKey: winThemesKey(draft.pursuitId)
                }),
                cache.invalidateQueries({
                    queryKey: [
                        'win-theme-history',
                        draft.pursuitId
                    ]
                }),
                cache.invalidateQueries({
                    queryKey: outputsKey(draft.pursuitId)
                })
            ]);
        }
    });
}
/** Plain-words message for a failed save. */ export function saveErrorMessage(cause) {
    const error = ConnectError.from(cause);
    if (error.code === Code.InvalidArgument) return error.rawMessage || 'This Win Theme could not be saved. Its Customer Theme may no longer be accepted.';
    if (error.code === Code.PermissionDenied) return 'You do not have permission to change Win Themes on this Pursuit.';
    return 'The Win Theme could not be saved. Your changes are kept here. Try again.';
}
